module.exports = "/_next/static/images/RobustMarketingAppstore@2x-831c17bc07087527f2dc7a8bfb78381f.png";